import React, { useEffect, useRef, useState } from 'react';
import './videos.css';
import thumbnail from '../../images/video-thumbnails/why-autzu.png';

const BlackTop = () => {
  return (
    <div className="black-container">
      <div className="middle-container">
        <div className="video-text">Why Autzu?</div>
        <div className="big-video-container">
          <video
            controls
            className="big-video-frame"
            poster={thumbnail}
            controlsList="nodownload"
            onContextMenu={e => e.preventDefault()}>
            <source
              src={'https://d1ngkkk2ntpizc.cloudfront.net/autzu_final.mp4'}
              type="video/mp4"
            />
          </video>
        </div>
      </div>
    </div>
  );
};

export default BlackTop;



// WEBPACK FOOTER //
// ./src/components/Videos/BlackTop.js